import type { ReactNode } from "react";
import { Button, Popconfirm } from "antd";

interface Props {
  selectedCount: number;
  itemLabel: string; // "이미지" | "슬라이드" | "그로스 이미지"
  onDeleteSelected: () => void;
  onClear: () => void;
  extraActions?: ReactNode; // 선택 시 삭제 버튼 앞에 추가로 노출할 액션 (예: 변환/이동)
}

export const MediaSelectionToolbar = ({
  selectedCount,
  itemLabel,
  onDeleteSelected,
  onClear,
  extraActions,
}: Props) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 8,
      padding: "8px 24px",
      borderBottom: "1px solid #f0f0f0",
      minHeight: 40,
    }}
  >
    <span style={{ fontSize: 12, color: selectedCount > 0 ? "#1677ff" : "#999" }}>
      {selectedCount > 0
        ? `${selectedCount}개 선택됨`
        : "Ctrl(⌘)+클릭으로 여러 개, Shift+클릭·드래그로 범위를 선택할 수 있습니다."}
    </span>
    {selectedCount > 0 && (
      <div style={{ flexShrink: 0, display: "flex", alignItems: "center", gap: 8 }}>
        {extraActions}
        <Popconfirm
          title={`선택한 ${itemLabel} 삭제`}
          description={`선택한 ${selectedCount}개를 삭제하시겠습니까?`}
          onConfirm={onDeleteSelected}
          okText="삭제"
          cancelText="취소"
        >
          <Button danger size="small">
            선택 파일 삭제
          </Button>
        </Popconfirm>
        <Button size="small" onClick={onClear}>
          선택 해제
        </Button>
      </div>
    )}
  </div>
);

export default MediaSelectionToolbar;
